// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fg-color-white
{
    color: white !important;
}
.fg-color-blue
{
    color: rgb(0, 74, 135) !important;
}
.fg-color-blue1
{
    color: rgba(0, 74, 135, 0.75) !important;
}
.fg-color-blue2
{
    color: rgba(0, 74, 135, 0.5) !important;
}
.fg-color-green
{
    color: rgb(128, 189, 1) !important;
}
.fg-color-green1
{
    color: rgba(128, 189, 1, 0.75) !important;
}
.fg-color-green2
{
    color: rgba(128, 189, 1, 0.5) !important;
}
.fg-color-green3
{
    color: rgba(128, 189, 1, 0.25) !important;
}
.fg-color-orange
{
    color: rgb(255, 164, 9) !important;
}
.fg-color-orange1
{
    color: rgba(255, 164, 9, 0.75) !important;
}
.fg-color-orange2
{
    color: rgba(255, 164, 9, 0.5) !important;
}
.fg-color-red
{
    color: rgb(252, 66, 55) !important;
}
.fg-color-red1
{
    color: rgba(252, 66, 55, 0.75) !important;
}
.fg-color-red2
{
    color: rgba(252, 66, 55, 0.5) !important;
}
.fg-color-gray
{
    color: rgb(86, 86, 90) !important;
}
.fg-color-gray1
{
    color: rgba(86, 86, 90, 0.75) !important;
}
.fg-color-gray2
{
    color: rgba(86, 86, 90, 0.5) !important;
}
.fg-color-gray3
{
    color: rgba(86, 86, 90, 0.25) !important;
}

.fg-color-transparent
{
    color: transparent !important;
}



.bg-color-blue
{
    background-color: rgb(0, 74, 135) !important;
}
.bg-color-blue2
{
    background-color: rgba(0, 74, 135, 0.5) !important;
}
.bg-color-blue3
{
    background-color: rgba(0, 74, 135, 0.25) !important;
}
.bg-color-green
{
    background-color: rgb(128, 189, 1) !important;
}
.bg-color-green1
{
    background-color: rgba(128, 189, 1, 0.75) !important;
}
.bg-color-green2
{
    background-color: rgba(128, 189, 1, 0.5) !important;
}
.bg-color-green3
{
    background-color: rgba(128, 189, 1, 0.25) !important;
}
.bg-color-green4
{
    background-color: rgba(128, 189, 1, 0.1) !important;
}
.bg-color-orange
{
    background-color: rgb(255, 164, 9) !important;
}
.bg-color-orange1
{
    background-color: rgba(255, 164, 9, 0.75) !important;
}
.bg-color-orange2
{
    background-color: rgba(255, 164, 9, 0.5) !important;
}
.bg-color-orange3
{
    background-color: rgba(255, 164, 9, 0.25) !important;
}
.bg-color-orange4
{
    background-color: rgba(255, 164, 9, 0.10) !important;
}
.bg-color-red
{
    background-color: rgb(252, 66, 55) !important;
}
.bg-color-red1
{
    background-color: rgba(252, 66, 55, 0.75) !important;
}
.bg-color-red2
{
    background-color: rgba(252, 66, 55, 0.5) !important;
}
.bg-color-red3
{
    background-color: rgba(252, 66, 55, 0.25) !important;
}
.bg-color-red4
{
    background-color: rgba(252, 66, 55, 0.1) !important;
}
.bg-color-gray
{
    background-color: rgb(86, 86, 90) !important;
}
.bg-color-gray1
{
    background-color: rgba(86, 86, 90, 0.75) !important;
}
.bg-color-gray2
{
    background-color: rgba(86, 86, 90, 0.5) !important;
}
.bg-color-gray3
{
    background-color: rgba(86, 86, 90, 0.25) !important;
}
.bg-color-gray4
{
    background-color: rgba(86, 86, 90, 0.10) !important;
}
.bg-color-gray5
{
    background-color: rgba(86, 86, 90, 0.05) !important;
}
.bg-color-gray6
{
    background-color: rgba(86, 86, 90, 0.03) !important;
}


.border-color-red
{
    border-color: rgb(252, 66, 55) !important;
}
.border-color-red1
{
    border-color: rgba(252, 66, 55, 0.75) !important;
}
.border-color-red2
{
    border-color: rgba(252, 66, 55, 0.5) !important;
}

.page-sidebar  > ul > li.sticker.sticker-color-orange:before
{
    background-color: rgb(255, 164, 9) !important;
}

.page-sidebar  > ul > li.sticker.sticker-color-blue:before
{
    background-color: rgb(0, 74, 135) !important;
}

.bg-red {
    background-color: #e6194B;
    color: #fff;
}

.bg-green {
    background-color: #3cb44b;
    color: #fff;
}

.bg-yellow {
    background-color: #ffe119;
    color: #000;
}

.bg-blue {
    background-color: #4363d8;
    color: #fff;
}

.bg-orange {
    background-color: #f58231;
    color: #fff;
}

.bg-purple {
    background-color: #911eb4;
    color: #fff;
}

.bg-cyan {
    background-color: #42d4f4;
    color: #000;
}

.bg-magenta {
    background-color: #f032e6;
    color: #fff;
}

.bg-lime {
    background-color: #bfef45;
    color: #000;
}

.bg-pink {
    background-color: #fabebe;
    color: #000;
}

.bg-teal {
    background-color: #469990;
    color: #fff;
}

.bg-lavender {
    background-color: #e6beff;
    color: #000;
}

.bg-brown {
    background-color: #9A6324;
    color: #fff;
}

.bg-beige {
    background-color: #fffac8;
    color: #000;
}

.bg-maroon {
    background-color: #800000;
    color: #fff;
}

.bg-mint {
    background-color: #aaffc3;
    color: #000;
}

.bg-olive {
    background-color: #808000;
    color: #fff;
}

.bg-apricot {
    background-color: #ffd8b1;
    color: #000;
}

.bg-navy {
    background-color: #000075;
    color: #fff;
}

.bg-grey {
    background-color: #a9a9a9;
    color: #fff;
}

.bg-white {
    background-color: #ffffff;
    color: #000;
}

.bg-black {
    background-color: #000000;
    color: #fff;
}

.bg-DarkBlue {
    background-color: #000066;
}
.bg-DarkGreen {
    background-color: #003300;
}
.bg-DarkRed {
    background-color: #660000;
}
.bg-DarkOrange {
    background-color: #CC6600;
}
.bg-DarkPurple {
    background-color: #660066;
}
.bg-MidBlue {
    background-color: #0033CC;
}
.bg-MidGreen {
    background-color: #006600;
}
.bg-MidRed {
    background-color: #990000;
}
.bg-MidOrange {
    background-color: #FF6600;
}
.bg-MidPurple {
    background-color: #990066;
}
.bg-LightBlue {
    background-color: #0099FF;
}
.bg-LightGreen {
    background-color: #00CC00;
}
.bg-LightRed {
    background-color: #CC0000;
}
.bg-LightOrange {
    background-color: #FF9900;
}
.bg-MidPink {
    background-color: #CC0099;
}
.bg-BrightBlue {
    background-color: #00CCFF;
}
.bg-BrightGreen {
    background-color: #00FF00;
}
.bg-BrightRed {
    background-color: #FF0000;
}
.bg-BrightOrange {
    background-color: #FFCC00;
}
.bg-BrightPink {
    background-color:#FF00CC;
}


/*Charts pallete*/

.bg-tch-gray {
    background-color: #56565a !important;
    color: #fff !important;
}

.bg-tch-orange {
    background-color: #ff9924 !important;
    color: #fff !important;
}
.bg-tch-red {
    background-color: #ff0e00 !important;
    color: #fff !important;
}
.bg-tch-grassGreen {
    background-color: #7cfc00 !important;
    color: #000 !important;
}
.bg-tch-blue {
    background-color: #004A87 !important;
    color: #fff !important;
}
.bg-tch-fuchsia {
    background-color: #FF00FF !important;
    color: #fff !important;
}
.bg-tch-green {
    background-color: #80BD01 !important;
    color: #fff !important;
}
.bg-tch-electricBlue {
    background-color: #7DF9FF !important;
    color: #000 !important;
}
.bg-tch-silver {
    background-color: #C0C0C0 !important;
    color: #fff !important;
}
.bg-tch-citrine {
    background-color: #E4D00A !important;
    color: #fff !important;
}
.bg-tch-blueGray {
    background-color: #7393B3 !important;
    color: #fff !important;
}
.bg-tch-tan {
    background-color: #D2B48C !important;
    color: #fff !important;
}
.bg-tch-black {
    background-color: #000 !important;
    color: #fff !important;
}
.bg-tch-purple {
    background-color: #800080 !important;
    color: #fff !important;
}
.bg-tch-thistle {
    background-color: #D8BFD8 !important;
    color: #000 !important;
}
.bg-tch-gold {
    background-color: #FFD700 !important;
    color: #fff !important;
}
.bg-tch-darkYellow {
    background-color: #8B8000 !important;
    color: #fff !important;
}
.bg-tch-coffee {
    background-color: #6F4E37 !important;
    color: #fff !important;
}
.bg-tch-raspberry {
    background-color: #E30B5C !important;
    color: #fff !important;
}
.bg-tch-chartreuse {
    background-color: #DFFF00 !important;
    color: #000 !important;
}

    .bg-tch-gray a,
    .bg-tch-orange a,
    .bg-tch-red a,
    .bg-tch-blue a,
    .bg-tch-fuchsia a,
    .bg-tch-green a,
    .bg-tch-electricBlue a,
    .bg-tch-silver a,
    .bg-tch-citrine a,
    .bg-tch-blueGray a,
    .bg-tch-tan a,
    .bg-tch-black a,
    .bg-tch-purple a,
    .bg-tch-gold a,
    .bg-tch-darkYellow a,
    .bg-tch-coffee a,
    .bg-tch-raspberry a,
    .bg-tch-chartreuse a 
    {
        color: #fff !important;
    }

.bg-tch-grassGreen a,
.bg-tch-thistle a 
{
    color: #000 !important;
}
`, "",{"version":3,"sources":["webpack://./App/Web/Styles/Colors.css"],"names":[],"mappings":"AAAA;;IAEI,uBAAuB;AAC3B;AACA;;IAEI,iCAAiC;AACrC;AACA;;IAEI,wCAAwC;AAC5C;AACA;;IAEI,uCAAuC;AAC3C;AACA;;IAEI,kCAAkC;AACtC;AACA;;IAEI,yCAAyC;AAC7C;AACA;;IAEI,wCAAwC;AAC5C;AACA;;IAEI,yCAAyC;AAC7C;AACA;;IAEI,kCAAkC;AACtC;AACA;;IAEI,yCAAyC;AAC7C;AACA;;IAEI,wCAAwC;AAC5C;AACA;;IAEI,kCAAkC;AACtC;AACA;;IAEI,yCAAyC;AAC7C;AACA;;IAEI,wCAAwC;AAC5C;AACA;;IAEI,iCAAiC;AACrC;AACA;;IAEI,wCAAwC;AAC5C;AACA;;IAEI,uCAAuC;AAC3C;AACA;;IAEI,wCAAwC;AAC5C;;AAEA;;IAEI,6BAA6B;AACjC;;;;AAIA;;IAEI,4CAA4C;AAChD;AACA;;IAEI,kDAAkD;AACtD;AACA;;IAEI,mDAAmD;AACvD;AACA;;IAEI,6CAA6C;AACjD;AACA;;IAEI,oDAAoD;AACxD;AACA;;IAEI,mDAAmD;AACvD;AACA;;IAEI,oDAAoD;AACxD;AACA;;IAEI,mDAAmD;AACvD;AACA;;IAEI,6CAA6C;AACjD;AACA;;IAEI,oDAAoD;AACxD;AACA;;IAEI,mDAAmD;AACvD;AACA;;IAEI,oDAAoD;AACxD;AACA;;IAEI,oDAAoD;AACxD;AACA;;IAEI,6CAA6C;AACjD;AACA;;IAEI,oDAAoD;AACxD;AACA;;IAEI,mDAAmD;AACvD;AACA;;IAEI,oDAAoD;AACxD;AACA;;IAEI,mDAAmD;AACvD;AACA;;IAEI,4CAA4C;AAChD;AACA;;IAEI,mDAAmD;AACvD;AACA;;IAEI,kDAAkD;AACtD;AACA;;IAEI,mDAAmD;AACvD;AACA;;IAEI,mDAAmD;AACvD;AACA;;IAEI,mDAAmD;AACvD;AACA;;IAEI,mDAAmD;AACvD;;;AAGA;;IAEI,yCAAyC;AAC7C;AACA;;IAEI,gDAAgD;AACpD;AACA;;IAEI,+CAA+C;AACnD;;AAEA;;IAEI,6CAA6C;AACjD;;AAEA;;IAEI,4CAA4C;AAChD;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,wBAAwB;AAC5B;;;AAGA,iBAAiB;;AAEjB;IACI,oCAAoC;IACpC,sBAAsB;AAC1B;;AAEA;IACI,oCAAoC;IACpC,sBAAsB;AAC1B;AACA;IACI,oCAAoC;IACpC,sBAAsB;AAC1B;AACA;IACI,oCAAoC;IACpC,sBAAsB;AAC1B;AACA;IACI,oCAAoC;IACpC,sBAAsB;AAC1B;AACA;IACI,oCAAoC;IACpC,sBAAsB;AAC1B;AACA;IACI,oCAAoC;IACpC,sBAAsB;AAC1B;AACA;IACI,oCAAoC;IACpC,sBAAsB;AAC1B;AACA;IACI,oCAAoC;IACpC,sBAAsB;AAC1B;AACA;IACI,oCAAoC;IACpC,sBAAsB;AAC1B;AACA;IACI,oCAAoC;IACpC,sBAAsB;AAC1B;AACA;IACI,oCAAoC;IACpC,sBAAsB;AAC1B;AACA;IACI,iCAAiC;IACjC,sBAAsB;AAC1B;AACA;IACI,oCAAoC;IACpC,sBAAsB;AAC1B;AACA;IACI,oCAAoC;IACpC,sBAAsB;AAC1B;AACA;IACI,oCAAoC;IACpC,sBAAsB;AAC1B;AACA;IACI,oCAAoC;IACpC,sBAAsB;AAC1B;AACA;IACI,oCAAoC;IACpC,sBAAsB;AAC1B;AACA;IACI,oCAAoC;IACpC,sBAAsB;AAC1B;AACA;IACI,oCAAoC;IACpC,sBAAsB;AAC1B;;IAEI;;;;;;;;;;;;;;;;;;;QAmBI,sBAAsB;IAC1B;;AAEJ;;;IAGI,sBAAsB;AAC1B","sourcesContent":[".fg-color-white\n{\n    color: white !important;\n}\n.fg-color-blue\n{\n    color: rgb(0, 74, 135) !important;\n}\n.fg-color-blue1\n{\n    color: rgba(0, 74, 135, 0.75) !important;\n}\n.fg-color-blue2\n{\n    color: rgba(0, 74, 135, 0.5) !important;\n}\n.fg-color-green\n{\n    color: rgb(128, 189, 1) !important;\n}\n.fg-color-green1\n{\n    color: rgba(128, 189, 1, 0.75) !important;\n}\n.fg-color-green2\n{\n    color: rgba(128, 189, 1, 0.5) !important;\n}\n.fg-color-green3\n{\n    color: rgba(128, 189, 1, 0.25) !important;\n}\n.fg-color-orange\n{\n    color: rgb(255, 164, 9) !important;\n}\n.fg-color-orange1\n{\n    color: rgba(255, 164, 9, 0.75) !important;\n}\n.fg-color-orange2\n{\n    color: rgba(255, 164, 9, 0.5) !important;\n}\n.fg-color-red\n{\n    color: rgb(252, 66, 55) !important;\n}\n.fg-color-red1\n{\n    color: rgba(252, 66, 55, 0.75) !important;\n}\n.fg-color-red2\n{\n    color: rgba(252, 66, 55, 0.5) !important;\n}\n.fg-color-gray\n{\n    color: rgb(86, 86, 90) !important;\n}\n.fg-color-gray1\n{\n    color: rgba(86, 86, 90, 0.75) !important;\n}\n.fg-color-gray2\n{\n    color: rgba(86, 86, 90, 0.5) !important;\n}\n.fg-color-gray3\n{\n    color: rgba(86, 86, 90, 0.25) !important;\n}\n\n.fg-color-transparent\n{\n    color: transparent !important;\n}\n\n\n\n.bg-color-blue\n{\n    background-color: rgb(0, 74, 135) !important;\n}\n.bg-color-blue2\n{\n    background-color: rgba(0, 74, 135, 0.5) !important;\n}\n.bg-color-blue3\n{\n    background-color: rgba(0, 74, 135, 0.25) !important;\n}\n.bg-color-green\n{\n    background-color: rgb(128, 189, 1) !important;\n}\n.bg-color-green1\n{\n    background-color: rgba(128, 189, 1, 0.75) !important;\n}\n.bg-color-green2\n{\n    background-color: rgba(128, 189, 1, 0.5) !important;\n}\n.bg-color-green3\n{\n    background-color: rgba(128, 189, 1, 0.25) !important;\n}\n.bg-color-green4\n{\n    background-color: rgba(128, 189, 1, 0.1) !important;\n}\n.bg-color-orange\n{\n    background-color: rgb(255, 164, 9) !important;\n}\n.bg-color-orange1\n{\n    background-color: rgba(255, 164, 9, 0.75) !important;\n}\n.bg-color-orange2\n{\n    background-color: rgba(255, 164, 9, 0.5) !important;\n}\n.bg-color-orange3\n{\n    background-color: rgba(255, 164, 9, 0.25) !important;\n}\n.bg-color-orange4\n{\n    background-color: rgba(255, 164, 9, 0.10) !important;\n}\n.bg-color-red\n{\n    background-color: rgb(252, 66, 55) !important;\n}\n.bg-color-red1\n{\n    background-color: rgba(252, 66, 55, 0.75) !important;\n}\n.bg-color-red2\n{\n    background-color: rgba(252, 66, 55, 0.5) !important;\n}\n.bg-color-red3\n{\n    background-color: rgba(252, 66, 55, 0.25) !important;\n}\n.bg-color-red4\n{\n    background-color: rgba(252, 66, 55, 0.1) !important;\n}\n.bg-color-gray\n{\n    background-color: rgb(86, 86, 90) !important;\n}\n.bg-color-gray1\n{\n    background-color: rgba(86, 86, 90, 0.75) !important;\n}\n.bg-color-gray2\n{\n    background-color: rgba(86, 86, 90, 0.5) !important;\n}\n.bg-color-gray3\n{\n    background-color: rgba(86, 86, 90, 0.25) !important;\n}\n.bg-color-gray4\n{\n    background-color: rgba(86, 86, 90, 0.10) !important;\n}\n.bg-color-gray5\n{\n    background-color: rgba(86, 86, 90, 0.05) !important;\n}\n.bg-color-gray6\n{\n    background-color: rgba(86, 86, 90, 0.03) !important;\n}\n\n\n.border-color-red\n{\n    border-color: rgb(252, 66, 55) !important;\n}\n.border-color-red1\n{\n    border-color: rgba(252, 66, 55, 0.75) !important;\n}\n.border-color-red2\n{\n    border-color: rgba(252, 66, 55, 0.5) !important;\n}\n\n.page-sidebar  > ul > li.sticker.sticker-color-orange:before\n{\n    background-color: rgb(255, 164, 9) !important;\n}\n\n.page-sidebar  > ul > li.sticker.sticker-color-blue:before\n{\n    background-color: rgb(0, 74, 135) !important;\n}\n\n.bg-red {\n    background-color: #e6194B;\n    color: #fff;\n}\n\n.bg-green {\n    background-color: #3cb44b;\n    color: #fff;\n}\n\n.bg-yellow {\n    background-color: #ffe119;\n    color: #000;\n}\n\n.bg-blue {\n    background-color: #4363d8;\n    color: #fff;\n}\n\n.bg-orange {\n    background-color: #f58231;\n    color: #fff;\n}\n\n.bg-purple {\n    background-color: #911eb4;\n    color: #fff;\n}\n\n.bg-cyan {\n    background-color: #42d4f4;\n    color: #000;\n}\n\n.bg-magenta {\n    background-color: #f032e6;\n    color: #fff;\n}\n\n.bg-lime {\n    background-color: #bfef45;\n    color: #000;\n}\n\n.bg-pink {\n    background-color: #fabebe;\n    color: #000;\n}\n\n.bg-teal {\n    background-color: #469990;\n    color: #fff;\n}\n\n.bg-lavender {\n    background-color: #e6beff;\n    color: #000;\n}\n\n.bg-brown {\n    background-color: #9A6324;\n    color: #fff;\n}\n\n.bg-beige {\n    background-color: #fffac8;\n    color: #000;\n}\n\n.bg-maroon {\n    background-color: #800000;\n    color: #fff;\n}\n\n.bg-mint {\n    background-color: #aaffc3;\n    color: #000;\n}\n\n.bg-olive {\n    background-color: #808000;\n    color: #fff;\n}\n\n.bg-apricot {\n    background-color: #ffd8b1;\n    color: #000;\n}\n\n.bg-navy {\n    background-color: #000075;\n    color: #fff;\n}\n\n.bg-grey {\n    background-color: #a9a9a9;\n    color: #fff;\n}\n\n.bg-white {\n    background-color: #ffffff;\n    color: #000;\n}\n\n.bg-black {\n    background-color: #000000;\n    color: #fff;\n}\n\n.bg-DarkBlue {\n    background-color: #000066;\n}\n.bg-DarkGreen {\n    background-color: #003300;\n}\n.bg-DarkRed {\n    background-color: #660000;\n}\n.bg-DarkOrange {\n    background-color: #CC6600;\n}\n.bg-DarkPurple {\n    background-color: #660066;\n}\n.bg-MidBlue {\n    background-color: #0033CC;\n}\n.bg-MidGreen {\n    background-color: #006600;\n}\n.bg-MidRed {\n    background-color: #990000;\n}\n.bg-MidOrange {\n    background-color: #FF6600;\n}\n.bg-MidPurple {\n    background-color: #990066;\n}\n.bg-LightBlue {\n    background-color: #0099FF;\n}\n.bg-LightGreen {\n    background-color: #00CC00;\n}\n.bg-LightRed {\n    background-color: #CC0000;\n}\n.bg-LightOrange {\n    background-color: #FF9900;\n}\n.bg-MidPink {\n    background-color: #CC0099;\n}\n.bg-BrightBlue {\n    background-color: #00CCFF;\n}\n.bg-BrightGreen {\n    background-color: #00FF00;\n}\n.bg-BrightRed {\n    background-color: #FF0000;\n}\n.bg-BrightOrange {\n    background-color: #FFCC00;\n}\n.bg-BrightPink {\n    background-color:#FF00CC;\n}\n\n\n/*Charts pallete*/\n\n.bg-tch-gray {\n    background-color: #56565a !important;\n    color: #fff !important;\n}\n\n.bg-tch-orange {\n    background-color: #ff9924 !important;\n    color: #fff !important;\n}\n.bg-tch-red {\n    background-color: #ff0e00 !important;\n    color: #fff !important;\n}\n.bg-tch-grassGreen {\n    background-color: #7cfc00 !important;\n    color: #000 !important;\n}\n.bg-tch-blue {\n    background-color: #004A87 !important;\n    color: #fff !important;\n}\n.bg-tch-fuchsia {\n    background-color: #FF00FF !important;\n    color: #fff !important;\n}\n.bg-tch-green {\n    background-color: #80BD01 !important;\n    color: #fff !important;\n}\n.bg-tch-electricBlue {\n    background-color: #7DF9FF !important;\n    color: #000 !important;\n}\n.bg-tch-silver {\n    background-color: #C0C0C0 !important;\n    color: #fff !important;\n}\n.bg-tch-citrine {\n    background-color: #E4D00A !important;\n    color: #fff !important;\n}\n.bg-tch-blueGray {\n    background-color: #7393B3 !important;\n    color: #fff !important;\n}\n.bg-tch-tan {\n    background-color: #D2B48C !important;\n    color: #fff !important;\n}\n.bg-tch-black {\n    background-color: #000 !important;\n    color: #fff !important;\n}\n.bg-tch-purple {\n    background-color: #800080 !important;\n    color: #fff !important;\n}\n.bg-tch-thistle {\n    background-color: #D8BFD8 !important;\n    color: #000 !important;\n}\n.bg-tch-gold {\n    background-color: #FFD700 !important;\n    color: #fff !important;\n}\n.bg-tch-darkYellow {\n    background-color: #8B8000 !important;\n    color: #fff !important;\n}\n.bg-tch-coffee {\n    background-color: #6F4E37 !important;\n    color: #fff !important;\n}\n.bg-tch-raspberry {\n    background-color: #E30B5C !important;\n    color: #fff !important;\n}\n.bg-tch-chartreuse {\n    background-color: #DFFF00 !important;\n    color: #000 !important;\n}\n\n    .bg-tch-gray a,\n    .bg-tch-orange a,\n    .bg-tch-red a,\n    .bg-tch-blue a,\n    .bg-tch-fuchsia a,\n    .bg-tch-green a,\n    .bg-tch-electricBlue a,\n    .bg-tch-silver a,\n    .bg-tch-citrine a,\n    .bg-tch-blueGray a,\n    .bg-tch-tan a,\n    .bg-tch-black a,\n    .bg-tch-purple a,\n    .bg-tch-gold a,\n    .bg-tch-darkYellow a,\n    .bg-tch-coffee a,\n    .bg-tch-raspberry a,\n    .bg-tch-chartreuse a \n    {\n        color: #fff !important;\n    }\n\n.bg-tch-grassGreen a,\n.bg-tch-thistle a \n{\n    color: #000 !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
